import { useCallback } from 'react';
import { useViewerStore } from '../../../../../store/store';
import { useOneButtonStore } from '../../../../../store/oneButtonStore';
import { runLoadSavedDesignsAction } from '../dashboardActionLoadSavedDesigns';
import { STABLE_EMPTY_ARRAY } from '../utils/stableEmpty';


export function useDashboardStoreBindings() {
    const loadingCompleted = useViewerStore((s) => s.loadingCompleted);
    const refreshingShadeFromStore = useViewerStore((s) => s.refreshingShade);
    const roofInfoArr = useViewerStore((s) => s.roofInfoArr ?? STABLE_EMPTY_ARRAY);
    const designListFromStore = useViewerStore((s: any) => (s.designList ?? STABLE_EMPTY_ARRAY) as any[]);
    const siteDesignDetailsFromStore = useViewerStore(
        (s: any) => (s.siteDesignDetails ?? STABLE_EMPTY_ARRAY) as any[],
    );
    const setSavedAIDesigns = useOneButtonStore((s) => s.setSavedAIDesigns);

    const setLoadingSavedResult = useCallback((next: boolean) => {
        useViewerStore.setState({ loadingSavedResult: next } as any);
    }, []);
    const setAiLoadingStep = useCallback((next: string) => {
        useViewerStore.setState({ aiLoadingStep: next } as any);
    }, []);
    const setLayoutModulesByKey = useCallback(
        (
            next:
                | Record<string, number>
                | ((prev: Record<string, number>) => Record<string, number>),
        ) => {
            const prev = ((useViewerStore.getState() as any).layoutModulesByKey || {}) as Record<string, number>;
            const resolved = typeof next === 'function' ? (next as (p: Record<string, number>) => Record<string, number>)(prev) : next;
            useViewerStore.setState({ layoutModulesByKey: resolved } as any);
        },
        [],
    );
    const setLayoutProductionByKey = useCallback(
        (next: Record<string, number> | ((prev: Record<string, number>) => Record<string, number>)) => {
            const prev = ((useViewerStore.getState() as any).layoutProductionByKey || {}) as Record<string, number>;
            const resolved = typeof next === 'function' ? (next as (p: Record<string, number>) => Record<string, number>)(prev) : next;
            useViewerStore.setState({ layoutProductionByKey: resolved } as any);
        },
        [],
    );
    const setLayoutMetricsByKey = useCallback(
        (next: Record<string, any> | ((prev: Record<string, any>) => Record<string, any>)) => {
            const prev = ((useViewerStore.getState() as any).layoutMetricsByKey || {}) as Record<string, any>;
            const resolved =
                typeof next === 'function' ? (next as (p: Record<string, any>) => Record<string, any>)(prev) : next;
            useViewerStore.setState({ layoutMetricsByKey: resolved } as any);
        },
        [],
    );
    const setAiScenariosSectionVisible = useCallback((next: boolean) => {
        useViewerStore.setState({ aiScenariosSectionVisible: next } as any);
    }, []);
    const setResultCardMinimizedForLoad = useCallback((next: boolean) => {
        useViewerStore.setState({ resultCardMinimized: next } as any);
    }, []);
    const setIsLoadingSnapshots = useCallback((next: boolean) => {
        useViewerStore.setState({ isLoadingSnapshots: next } as any);
    }, []);
    const setAiLoading = useCallback((next: boolean) => {
        useViewerStore.setState({ aiLoading: next } as any);
    }, []);
    const setLayoutSimulationTimeByKey = useCallback(
        (next: Record<string, number> | ((prev: Record<string, number>) => Record<string, number>)) => {
            const prev = ((useViewerStore.getState() as any).layoutSimulationTimeByKey || {}) as Record<string, number>;
            const resolved = typeof next === 'function' ? (next as (p: Record<string, number>) => Record<string, number>)(prev) : next;
            useViewerStore.setState({ layoutSimulationTimeByKey: resolved } as any);
        },
        [],
    );

    const handleLoadSavedDesigns = useCallback(async (options?: { showLoading?: boolean }) => {
        return runLoadSavedDesignsAction({
            setLoadingSavedResult,
            setAiLoadingStep,
            setSavedAIDesigns,
            setLayoutModulesByKey,
            setLayoutProductionByKey,
            setLayoutMetricsByKey,
            setAiScenariosSectionVisible,
            setResultCardMinimized: setResultCardMinimizedForLoad,
            setIsLoadingSnapshots,
            setAiLoading,
            showLoading: options?.showLoading,
        });
    }, [
        setLoadingSavedResult,
        setAiLoadingStep,
        setSavedAIDesigns,
        setLayoutModulesByKey,
        setLayoutProductionByKey,
        setLayoutMetricsByKey,
        setAiScenariosSectionVisible,
        setResultCardMinimizedForLoad,
        setIsLoadingSnapshots,
        setAiLoading,
    ]);


    return {
        loadingCompleted,
        refreshingShadeFromStore,
        roofInfoArr,
        designListFromStore,
        siteDesignDetailsFromStore,
        setAiLoadingStep,
        setLayoutModulesByKey,
        setLayoutProductionByKey,
        setLayoutMetricsByKey,
        setAiScenariosSectionVisible,
        setAiLoading,
        setLayoutSimulationTimeByKey,
        handleLoadSavedDesigns,
    };
}
